import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import ReactModal from 'react-modal';
import CloseIcon from '../../atoms/icons/CloseIcon';
import { getBackgroundTheme, getTextColor } from '../../style';
import { useDisableBodyElementScroll } from '../../hooks/useDisableBodyScroll';
import { IBasicModalProps } from './types/BasicModal';
import { IModalStyle } from './types';

ReactModal.setAppElement('body');

const setModalStyle = (customStyle: IModalStyle) => {
  const customOverlay = customStyle?.overlay || {};
  const customContent = customStyle?.content || {};

  return {
    overlay: {
      zIndex: 8000,
      backgroundColor: 'rgba(0,0,0,0.65)',
      overflowY: 'auto' as const,
      ...customOverlay,
    },
    content: {
      maxWidth: '520px',
      transform: 'scale(1)',
      margin: '0 auto',
      outline: 'none',
      top: '82px',
      bottom: 'initial',
      ':focus': {
        outline: 'none',
      },
      backgroundColor: getBackgroundTheme().block,
      ...customContent,
      ...getTextColor().DARK,
    },
  };
};

const Content = styled('div')({
  position: 'relative',
  minHeight: '75px',
});

const IconContainer = styled('div')({
  position: 'absolute',
  top: '-10px',
  right: '-10px',
  fontSize: '28px',
  lineHeight: '16px',
  '&:hover': {
    cursor: 'pointer',
  },
});

const BasicModal = ({
  closeOnOverlayClick = false,
  onClose,
  hideClose,
  customStyle,
  customContentStyle,
  children,
  ...rest
}: IBasicModalProps): ReactElement => {
  useDisableBodyElementScroll(rest.isOpen);

  return (
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    <ReactModal
      // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
      style={setModalStyle(customStyle)}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={closeOnOverlayClick}
      onRequestClose={onClose}
      {...rest}
    >
      <Content style={customContentStyle}>
        {!hideClose && (
          <IconContainer onClick={onClose}>
            <CloseIcon />
          </IconContainer>
        )}
        {children}
      </Content>
    </ReactModal>
  );
};

export default React.memo(BasicModal);
